<script setup lang="ts">
/** TMP087 — ROC Cover Letter (Section 76). 말레이어 serahsimpan 폼 재현. 토글/반복/Signers 없음.
 *  실제 변수: cosec_name, cosec_registration_no, cosec_address, cosec_phone, submission_reference,
 *  company, letter_date, tarikh_dokumen, event_date. */
import OtcDocVarField from './OtcDocVarField.vue';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-p"><b>Diserahkan oleh :</b></p>
    <p class="doc-p">
      <OtcDocVarField field-key="cosec_name" /><br />
      <OtcDocVarField field-key="cosec_registration_no" /><br />
      <OtcDocVarField field-key="cosec_address" />
    </p>
    <p class="doc-p">Tel &nbsp;: <OtcDocVarField field-key="cosec_phone" /></p>
    <p class="doc-p">Ruj. Kami : <OtcDocVarField field-key="submission_reference" /></p>

    <p class="doc-p"><b>Berkaitan :</b><br />SERAHSIMPAN DOKUMEN</p>
    <p class="doc-p">
      Nama Syarikat : <OtcDocVarField field-key="company_name" /><br />
      No. Rujukan &nbsp;: <OtcDocVarField field-key="company_registration_no" />
    </p>
    <p class="doc-p">Tarikh : <OtcDocVarField field-key="letter_date" /></p>

    <p class="doc-p">
      Tuan,<br />
      ( √ ) Bersama-sama ini disertakan dokumen / permohonan untuk pendaftaran / kelulusan mengikut kategori berikut –
      ( Sila √ di tempat berkenaan )
    </p>
    <!-- 문서 카테고리 체크리스트 — 원본 docx 재현. OTC(Section 76) 는 항상 "Lain-Lain Dokumen" 에 √. -->
    <div class="roc-cat">
      <div class="roc-row"><span class="roc-box"></span>Gadaian (Charges)</div>
      <div class="roc-row"><span class="roc-box"></span>Penerimaan (Receivership)</div>
      <div class="roc-row"><span class="roc-box"></span>Penggulungan (Winding-up)</div>
      <div class="roc-sub">( )&nbsp;&nbsp;Winding-up By Court Order</div>
      <div class="roc-sub">( )&nbsp;&nbsp;Winding-up By Members (Voluntary)</div>
      <div class="roc-sub">( )&nbsp;&nbsp;Winding-up By Creditors (Voluntary)</div>
      <div class="roc-sub">( )&nbsp;&nbsp;Strike Off (Section 308) – Statutory Declaration (SD)</div>
      <div class="roc-sub">( )&nbsp;&nbsp;Cessation of Foreign Company</div>
      <div class="roc-row"><span class="roc-box"></span>Dokumen Am</div>
      <div class="roc-row"><span class="roc-box"></span>Lesen Setiausaha Syarikat</div>
      <div class="roc-row"><span class="roc-box"></span>Juruaudit Syarikat</div>
      <div class="roc-row"><span class="roc-box roc-box--checked">√</span>Lain-Lain Dokumen *</div>
      <div class="roc-note">( )&nbsp;&nbsp;Dengan ini dikembalikan dokumen berikut setelah dipinda seperti yang dikehendaki dalam surat tuan bertarikh</div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr><th>Dokumen**</th><th>Tarikh Dokumen</th><th>Event Date***</th><th>Bayaran (RM)</th></tr>
        <tr>
          <td>Section 76</td>
          <td><OtcDocVarField field-key="tarikh_dokumen" /></td>
          <td><OtcDocVarField field-key="event_date" /></td>
          <td>NIL</td>
        </tr>
        <tr><td style="text-align:right"><b>Jumlah :</b></td><td colspan="3">NIL</td></tr>
      </tbody>
    </table>
    <p class="doc-p" style="margin-top:8px">Disertakan bayaran sebanyak NIL (Tunai/Wang Pos/Kiriman Wang/Cek/Bank Draf)</p>
    <p class="doc-p" style="margin-top:18px">Tandatangan :</p>
  </div>
</template>

<style scoped>
.roc-cat { margin: 8px 0 4px; font-size: 12px; line-height: 1.7; color: #111; }
.roc-row { display: flex; align-items: center; gap: 8px; }
.roc-box { flex: none; width: 40px; height: 16px; border: 1px solid #111; display: inline-flex; align-items: center; justify-content: center; font-weight: 700; }
.roc-box--checked { color: #111; }
.roc-sub { padding-left: 96px; }
.roc-note { margin-top: 4px; }
</style>
